import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReferralsPreRegistrationRoutingModule } from './referrals-pre-registration-routing.module';
import { ReferralsPreRegistrationJoiningComponent } from './referrals-pre-registration-joining/referrals-pre-registration-joining.component';
import { JoiningListItemComponent } from './partials/joining-list-item/joining-list-item.component';
import { JoiningFormComponent } from './partials/joining-form/joining-form.component';
import { KamonaModule } from '@mpt-fo/common/kamona/kamona.module';
import { LeanSharedModule } from '@mpt-fo/common/lean-shared/lean-shared.module';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';

@NgModule({
  declarations: [
    ReferralsPreRegistrationJoiningComponent,
    JoiningListItemComponent,
    JoiningFormComponent,
  ],
  imports: [
    CommonModule,
    ReferralsPreRegistrationRoutingModule,
	KamonaModule, LeanSharedModule, NzSkeletonModule
  ]
})
export class ReferralsPreRegistrationModule { }
